// Battery icons
import type { SvgIcon } from "@/types/svg";
import BatteryErrorIconSVG from "./assets/battery/battery_error.svg?react";
import BatteryFullIconSVG from "./assets/battery/battery_full.svg?react";
import BatteryGoodIconSVG from "./assets/battery/battery_good.svg?react";
import BatteryLowIconSVG from "./assets/battery/battery_low.svg?react";
import BatteryOkIconSVG from "./assets/battery/battery_ok.svg?react";
import BatteryUnknownIconSVG from "./assets/battery/battery_unknown.svg?react";
import PumpIconSVG from "./assets/pump.svg?react";
import ScheduleIconSVG from "./assets/schedule.svg?react";
import SensorIconSVG from "./assets/sensor.svg?react";
// Signal icons
import SignalErrorIconSVG from "./assets/signal/signal_error.svg?react";
import SignalFullIconSVG from "./assets/signal/signal_full.svg?react";
import SignalHighIconSVG from "./assets/signal/signal_high.svg?react";
import SignalLowIconSVG from "./assets/signal/signal_low.svg?react";
import SignalMediumIconSVG from "./assets/signal/signal_medium.svg?react";
import SignalUnknownIconSVG from "./assets/signal/signal_unknown.svg?react";
import SignalVeryLowIconSVG from "./assets/signal/signal_very_low.svg?react";
import ValveIconSVG from "./assets/valve.svg?react";
import ValveClosedIconSVG from "./assets/valve-closed.svg?react";
import ValveOpenIconSVG from "./assets/valve-open.svg?react";
import VerifiedIconSVG from "./assets/verified.svg?react";

export type CustomSVGIconComponent = SvgIcon;

/**
 * Custom SVG icons defined as svg files
 */
export const ValveClosed = ValveClosedIconSVG;
export const ValveOpen = ValveOpenIconSVG;
export const Schedule = ScheduleIconSVG;
export const Verified = VerifiedIconSVG;
export const Sensor = SensorIconSVG;
export const Pump = PumpIconSVG;
export const Valve = ValveIconSVG;
export const BatteryUnknown = BatteryUnknownIconSVG;
export const BatteryError = BatteryErrorIconSVG;
export const BatteryLow = BatteryLowIconSVG;
export const BatteryOk = BatteryOkIconSVG;
export const BatteryGood = BatteryGoodIconSVG;
export const BatteryFull = BatteryFullIconSVG;
export const SignalUnknown = SignalUnknownIconSVG;
export const SignalError = SignalErrorIconSVG;
export const SignalLow = SignalLowIconSVG;
export const SignalMedium = SignalMediumIconSVG;
export const SignalHigh = SignalHighIconSVG;
export const SignalFull = SignalFullIconSVG;
export const SignalVeryLow = SignalVeryLowIconSVG;
